var _defs, _rect, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroSpirits(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 0,
    x2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d49a6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c87f4f"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f1",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 20,
    floodColor: "#000",
    floodOpacity: 0.5
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 20,
    fill: "#1f1f1f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80,60)",
    filter: "url(#f1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(60,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 40,
    rx: 28,
    ry: 28,
    width: 120,
    height: 360,
    fill: "url(#g1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 10,
    rx: 12,
    width: 56,
    height: 36,
    fill: "#3b2b25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 300,
    width: 80,
    height: 12,
    rx: 6,
    fill: "#000",
    opacity: 0.08
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(380,160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20 q20 -40 60 -30 q40 10 60 30 v70 q0 18 -20 18 h-80 q-20 0 -20 -18 z",
    fill: "#f6e9df"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90,
    cy: 96,
    rx: 44,
    ry: 8,
    fill: "#000",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 40 q30 14 60 0",
    stroke: "#e6c9b0",
    strokeWidth: 6,
    fill: "none",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40,380)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C140 -40 300 -40 420 0",
    stroke: "#ffffff10",
    strokeWidth: 6,
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -14 C140 -54 300 -54 420 -14",
    stroke: "#ffffff06",
    strokeWidth: 12,
    fill: "none",
    strokeLinecap: "round"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40,30)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 160,
    height: 6,
    rx: 3,
    fill: "#ffffff08"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 18,
    width: 120,
    height: 6,
    rx: 3,
    fill: "#ffffff04"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroSpirits);
export default __webpack_public_path__ + "static/media/hero-spirits.c6a69e09036695cc6cb2cf9e7b872ece.svg";
export { ForwardRef as ReactComponent };